import {Component, ComponentFactoryResolver, OnInit, Type, ViewChild} from '@angular/core';
import {CommonsService} from "@core/service/commons.service";
import {BrowseDirective} from "@shared/components/browse/browse.directive";
import {BrowseService} from "@shared/components/browse/browse.service";
import {BrowseComponent} from "@shared/components/browse/abstract.browse.component";


/**
 * 用户浏览按钮
 */
@Component({
  selector: 'common-browse',
  template: '<div browser></div>'
})
export class CommonBrowseComponent implements OnInit {

  @ViewChild(BrowseDirective) browser: BrowseDirective;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private commonsService: CommonsService,
    private browseService: BrowseService
  ) {
  }


  ngOnInit() {
    this.browseService.browse$.subscribe(define => {
      this.loadComponent(define);
    })

  }

  loadComponent(define: any) {

    const factories = Array.from(this.componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.componentName === define.config.component);
    const factory = this.componentFactoryResolver.resolveComponentFactory(factoryClass);
    //let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.getComponent(define.config.component));
    let viewContainerRef = this.browser.viewContainerRef;
    viewContainerRef.clear();
    let componentRef = viewContainerRef.createComponent(factory);
    (<BrowseComponent>componentRef.instance).config = define.config;
    (<BrowseComponent>componentRef.instance).onCancel = define.onCancel;
    (<BrowseComponent>componentRef.instance).onOk = define.onOk;

  }
}
